<template>
  <div class="page_container userListPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>最新待办</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main_container">
      <el-table :data="todoList" height="62vh" style="width: 100%">
        <el-table-column prop="todono" label="待办事项工单号" width="180">
        </el-table-column>
        <el-table-column prop="todotypestr" label="待办事项类">
        </el-table-column>
        <el-table-column prop="truename" label="待办人姓名">
        </el-table-column>
        <el-table-column prop="mobile" label="待办人手机号">
        </el-table-column>
        <el-table-column prop="createdate" label="创建日期">
        </el-table-column>
        <el-table-column prop="todostatestr" label="状态" width="80">
        </el-table-column>
        <el-table-column prop="resultstr" label="处理结果" width="80">
        </el-table-column>
      </el-table>
      <!-- 分页 start -->
      <div class="pagination_wrap flex-rowc">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next, jumper"
          :page-size="20"
          :total="listTotal"
        >
        </el-pagination>
      </div>
      <!-- 分页 end -->
    </div>
  </div>
</template>
<script>
import { getTodoList } from "../api/api";
export default {
  name: "todo",
  data() {
    return {
      params: {
        pageindex: 1,
        pagesize: 5,
        openid: "",
      },
      todoList: [],
      listTotal: 0,
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  created() {
    let { USERINFO } = this.$store.state;
    this.params.openid = USERINFO.openid;
    this.getTodoList();
  },
  methods: {
    // 待办列表
    getTodoList() {
      getTodoList(this.params).then((res) => {
        this.todoList = res.list;
        this.listTotal = res.total;
      });
    },

    // 分页
    handleCurrentChange(e) {
      this.params.pageindex = e;
      this.getTodoList();
    },
  },
};
</script>
<style lang="less" scoped>
.userListPage {
  .main_container {
    margin: 20px auto;
  }
  /deep/ .el-tabs__item {
    position: relative;
    .badge {
      position: absolute;
      font-size: 12px;
      color: red;
      top: -8px;
    }
  }
  /deep/ .el-table .cell {
    position: relative;
    .badge_round {
      display: inline-block;
      width: 5px !important;
      height: 5px !important;
      border-radius: 50%;
      background: red;
      position: absolute;
      top: 3px;
    }
  }
  .red {
    color: red;
    font-size: 12px;
  }
}
</style>